import { getLayer, initializeSdk } from '@eventbrite/statsig';
import { AppProps } from './types';

export const LISTING_PAGE_EXPERIMENTS_LAYER = 'listing_page_experiments';

const DISPLAY_ORGANIZER_RATING_EXPERIMENT = {
    defaultValue: false,
    layer: LISTING_PAGE_EXPERIMENTS_LAYER,
    param: 'display_organizer_rating',
};

export const initializeStatsigSdk = async (app: AppProps) => {
    const isRepeatingEvent =
        app.event?.isSeriesParent && !!app.event?.childEvents;
    await initializeSdk({
        user: {
            userID: app.user.publicId,
            custom: {
                eventId: app.event?.id,
                organizerId: app.organizer?.id,
                ebDomain: app.env?.ebDomain,
                shouldShowCompactCheckout: app.event?.shouldShowCompactCheckout,
                isRepeatingEvent: isRepeatingEvent,
                onlineEvent: app.event?.isOnlineEvent,
                isSeriesParent: app.event?.isSeriesParent,
                isSeries: !!app.event?.childEvents?.length,
                listed: app.event?.isListed,
                isLive: app.event?.isLive,
                protected: app.event?.isProtected,
                isFree: !app.components.eventDetails.refund.isPaidEvent,
                isPaid: app.components.eventDetails.refund.isPaidEvent,
                isDonation: app.event?.hasDonationTicketsAvailable,
                salesStatus: app.event?.salesStatus.sales_status,
            },
        },
    });
};

export const isDisplayRatingExperientEnabled = () => {
    const value = getLayer(
        DISPLAY_ORGANIZER_RATING_EXPERIMENT.layer,
        DISPLAY_ORGANIZER_RATING_EXPERIMENT.param,
        DISPLAY_ORGANIZER_RATING_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};
